import React from "react";
import ContactUS from "../../containers/ContactUs/Index";

export default function ContactUs() {
    return (
        <div>
            <ContactUS />
        </div>
    );
}
